import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BracketsDesktop } from './BracketsDesktop';
import { BracketsMobile } from './BracketsMobile';
import { Table, TableTitle } from './styles';
import { useCurrentBreakpoint } from '../../utilities/hooks/useCurrentBreakpoint';
import { sizes, Sizes } from '../../utilities/media';
import { Text } from '../Text';
export var BracketsTable = function (_a) {
  var tableData = _a.tableData,
    title = _a.title;
  var currentBreakpoint = useCurrentBreakpoint();
  var columnLayout = sizes[currentBreakpoint] <= sizes[Sizes.TABLET];
  return _jsxs("div", {
    children: [title && _jsx(TableTitle, {
      children: _jsx(Text, {
        el: "p",
        styleName: "label",
        children: title
      })
    }), _jsx(Table, {
      hasTitle: !!title,
      children: columnLayout ? _jsx(BracketsMobile, {
        tableData: tableData
      }) : _jsx(BracketsDesktop, {
        tableData: tableData
      })
    })]
  });
};